import { createContext, useContext, type ReactNode } from 'react'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { api, type Me } from './api'

interface AuthValue {
  me: Me | null
  loading: boolean
  refresh: () => void
  logout: () => Promise<void>
  /** ¿Tiene esta capacidad a nivel global? Para la navegación del panel. */
  canGlobal: (capability: string) => boolean
}

const Ctx = createContext<AuthValue | null>(null)

export function AuthProvider({ children }: { children: ReactNode }) {
  const qc = useQueryClient()
  const { data, isLoading } = useQuery({
    queryKey: ['me'],
    queryFn: () => api.get<Me>('/auth/me'),
    retry: false,
    staleTime: 60_000,
  })

  const value: AuthValue = {
    me: data ?? null,
    loading: isLoading,
    refresh: () => void qc.invalidateQueries({ queryKey: ['me'] }),
    logout: async () => {
      await api.post('/auth/logout')
      qc.clear()
      window.location.href = '/login'
    },
    canGlobal: (capability) =>
      Boolean(data?.isSuperAdmin) || Boolean(data?.globalCapabilities.includes(capability)),
  }

  return <Ctx.Provider value={value}>{children}</Ctx.Provider>
}

export function useAuth(): AuthValue {
  const v = useContext(Ctx)
  if (!v) throw new Error('useAuth fuera del AuthProvider')
  return v
}
